import {Injectable} from '@angular/core';
import {ApiService} from "../api/api.service";
import {Observable, Subject} from "rxjs";
import {DomSanitizer} from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class AppMenuService {
  constructor(private readonly apiService: ApiService, private readonly sanitizer: DomSanitizer) {
  }

  private readonly dataMenus = new Subject<any>();
  private readonly dataSubject = new Subject<any>();
  private readonly dataHeaderSubject = new Subject<any>();

  fetchMenu(tag: string) {
    this.apiService.get<any>(`menuGroup/tag/${tag}/menus`).subscribe(response => {
        this.dataMenus.next(response);
        this.dataSubject.next(this.buildTreeArray(response));
      }
    )
  }

  // fetchMenuModule(moduleId: number) {
  //   this.apiService.get<any>(`menuGroup/module/${moduleId}/menus`).subscribe(response => {
  //       this.dataMenus.next(response);
  //       this.dataSubject.next(this.buildTreeArray(response));
  //     }
  //   )
  // }

  fetchMenuModule(moduleId: string) {
    this.apiService.get<any>(`menuGroup/module/${moduleId}/menus`).subscribe(response => {
        this.dataHeaderSubject.next(this.buildTreeArray(response));
      }
    )
  }

  fetchHeaderMenu(tag: string) {
    this.apiService.get<any>(`menuGroup/tag/${tag}/menus`).subscribe(response => {
        this.dataHeaderSubject.next(this.buildTreeArray(response));
      }
    )
  }

  getPurgeMenus(): Observable<any> {
    return this.dataMenus.asObservable();
  }

  getMenu(): Observable<any> {
    return this.dataSubject.asObservable();
  }

  getHeaderMenu(): Observable<any> {
    return this.dataHeaderSubject.asObservable();
  }

  buildTreeArray(flatArray: any) {
    let result: any[];
    result = [];

    const nodeMap = flatArray.reduce((acc: any, item: any) => {
      item.icon = item.icon && this.sanitizer.bypassSecurityTrustHtml(item.icon);
      acc[item.id] = {
        ...item,
        items: []
      };
      return acc;
    }, {});
    flatArray.forEach((item: any) => {
      item.icon = item.icon && this.sanitizer.bypassSecurityTrustHtml(item.icon);
      if (item.parentMenuId == null) {
        result.push(nodeMap[item.id]);
      } else {
        nodeMap[item.parentMenuId]?.items
          .push(nodeMap[item.id]);
      }
    });
    return result;
  }
}
